// extracted by mini-css-extract-plugin
export var results = "results-module--results--8cbf0";
export var results__col = "results-module--results__col--bc5e4";
export var results__img = "results-module--results__img--1d50e";
export var results__row = "results-module--results__row--09474";
export var results__subtitle = "results-module--results__subtitle--d938c";
export var results__text = "results-module--results__text--ea6a8";
export var results__title = "results-module--results__title--19ce8";
export var results__titleDesktop = "results-module--results__title--desktop--4efb3";
export var results__titleMobile = "results-module--results__title--mobile--87859";
export var results__wrapper = "results-module--results__wrapper--c8eef";
export var results__wrapperBorder = "results-module--results__wrapper--border--73e5a";
export var results__wrapperBorderMobile = "results-module--results__wrapper--border-mobile--d472b";
export var results__wrapperSpecial = "results-module--results__wrapper--special--fbd88";